module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_f_normal.ad7b2a38.png";